import React from 'react';
import { useTranslation } from 'react-i18next';

interface IConflictPanelProps {
    firstColumn: string;
    secondColumn: string;
    firstElem: React.ReactNode;
    secondElem: React.ReactNode;
}

export const ConflictPanel: React.FC<IConflictPanelProps> = ({ firstColumn, secondColumn, firstElem, secondElem }) => {
    const { t, i18n } = useTranslation();
    return (
        <div style={{ display: 'grid', gridTemplateColumns: `${firstColumn} ${secondColumn}`, gap: '.5rem' }}>
            {firstElem}
            {secondElem}
        </div>
    );
};
